import { syncReplayThruster } from './ReplayVolume.js'
import { replayTimelineRatioToTick, bindTimelineTrackScrub } from './ReplayTimeline.js'

const icon = x => `<svg viewBox="0 0 20 20" aria-hidden="true">${x}</svg>`

export const replayerIcons = Object.freeze({
  play: icon('<path fill="currentColor" d="M5 5.48v9.04c0 1.12 1.2 1.84 2.19 1.3l8.39-4.51a1.48 1.48 0 0 0 0-2.62l-8.4-4.51A1.48 1.48 0 0 0 5 5.48"/>'),
  pause: icon('<g fill="currentColor"><rect width="3.5" height="12" x="4" y="4" rx="1" ry="1"/><rect width="3.5" height="12" x="12.5" y="4" rx="1" ry="1"/></g>'),
  rewind: icon('<g fill="currentColor" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="m10.89 9.24 4.46-3.83a1 1 0 0 1 1.65.76v7.66a1 1 0 0 1-1.65.76l-4.46-3.83a1 1 0 0 1 0-1.52M2.89 9.24l4.46-3.83A1 1 0 0 1 9 6.17v7.66a1 1 0 0 1-1.65.76l-4.46-3.83a1 1 0 0 1 0-1.52"/></g>'),
  ff: icon('<g fill="currentColor" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="m9.11 10.76-4.46 3.83A1 1 0 0 1 3 13.83V6.17a1 1 0 0 1 1.65-.76l4.46 3.83a1 1 0 0 1 0 1.52M17.11 10.76l-4.46 3.83a1 1 0 0 1-1.65-.76V6.17a1 1 0 0 1 1.65-.76l4.46 3.83a1 1 0 0 1 0 1.52"/></g>'),
  fullscreen: icon('<g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="M12 17h5v-5M17 17l-5-5M8 3H3v5M3 3l5 5"/></g>'),
  fullscreenExit: icon('<g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="M17 12h-5v5M12 12l5 5M3 8h5V3M8 8 3 3"/></g>'),
  close: icon('<g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="m5 5 10 10M5 15 15 5"/></g>'),
  chevL: icon('<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m12 3-5 7 5 7"/>'),
  chevR: icon('<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m8 17 5-7-5-7"/>'),
  volumeMuted: icon('<path fill="currentColor" d="M11.2 18.21a1.39 1.39 0 0 0 2.13-1.17V8.91L6.7 15.32zm0-16.42L5.31 5.56H2.5A2.5 2.5 0 0 0 0 8.06v3.88a2.5 2.5 0 0 0 2.5 2.5h.29L.26 16.9a.83.83 0 0 0 .57 1.44q.34-.02.58-.24l15.56-15a.83.83 0 0 0-1.16-1.2l-2.48 2.39V2.96c0-.5-.27-.97-.72-1.23-.44-.23-1-.2-1.41.06"/>'),
  volumeUnmuted: icon('<path fill="currentColor" d="M12.61 1.74a1.4 1.4 0 0 0-1.41.05L5.31 5.56H2.5A2.5 2.5 0 0 0 0 8.06v3.88a2.5 2.5 0 0 0 2.5 2.5h2.81l5.89 3.77a1.39 1.39 0 0 0 2.13-1.17V2.96c0-.5-.27-.97-.72-1.23m2.97 5.94q.16.06.28.19v-.02a3.03 3.03 0 0 1 0 4.34.83.83 0 0 1-1.18-1.18 1.4 1.4 0 0 0 0-1.97.83.83 0 0 1 .9-1.36M17 5.69a.8.8 0 0 0 0 1.18 4.44 4.44 0 0 1 0 6.29.83.83 0 0 0 1.18 1.17 6.07 6.07 0 0 0 0-8.64.83.83 0 0 0-1.18 0"/>'),
  watchReplay: icon('<path fill="currentColor" d="M11.97 11.05 8.42 8.64a.9.9 0 0 0-1.4.74v4.82a.9.9 0 0 0 1.4.73l3.55-2.4a.9.9 0 0 0 0-1.48 M0 16.25V7.32a3.15 3.15 0 0 1 3.15-3.15h5.97a.77.77 0 1 1 0 1.54H3.15c-.89 0-1.61.72-1.61 1.61v8.93c0 .9.72 1.62 1.61 1.62h12.5c.9 0 1.62-.73 1.62-1.62v-4.5a.77.77 0 1 1 1.54 0v4.5a3.15 3.15 0 0 1-3.15 3.15H3.16A3.15 3.15 0 0 1 0 16.25 M18.46 1.36a.77.77 0 0 1 1.54 0v2.98c0 .43-.34.77-.77.77h-2.98a.77.77 0 0 1 0-1.54h1.58a2.5 2.5 0 1 0-.05 3.39A.77.77 0 0 1 18.9 8a4.04 4.04 0 1 1-.44-5.95z"/>'),
  share: icon('<path fill="currentColor" d="M11 1.4q.5-.2 1 .2l7.7 7.8a1 1 0 0 1 0 1.2L12 18.4a1 1 0 0 1-1.5-.6v-4.3c-3.2.2-5.3 1.2-6.7 2.1a9 9 0 0 0-2 2A1 1 0 0 1 0 17v-.5a12 12 0 0 1 1.4-4.8 10 10 0 0 1 3.4-3.6Q7 6.8 10.4 6.5V2.2q0-.5.6-.8"/>')
})

export function replayerHtml() {
  return `
  <div class="replay-stage" data-role="fullscreen-target">
    <button type="button" class="replay-volume" data-role="replay-volume" aria-label="Unmute">${replayerIcons.volumeMuted}</button>
    <div class="replay-stage-top-actions">
      <div class="replay-share-stack">
        <span class="replay-floating-label" data-role="copy-replay-toast" aria-live="polite" aria-hidden="true">Link copied!</span>
        <button type="button" class="replay-icon-btn" data-role="copy-replay-link" aria-label="Copy replay link to clipboard" title="Copy replay link to clipboard">${replayerIcons.share}</button>
      </div>
      <button type="button" class="replay-close" data-role="close-replay" aria-label="Close">${replayerIcons.close}</button>
    </div>
    <canvas data-role="surface" width="960" height="540"></canvas>
    <div class="controls">
      <div class="replay-timeline" role="group" aria-label="Seek timeline">
        <span class="replay-viewer-meta" data-role="tick-label"><span data-role="tick-cur">0</span><span class="replay-tick-sep">/</span><span data-role="tick-max">0</span></span>
        <div class="replay-track-wrap" data-role="track-hit">
          <span class="replay-track" data-role="track-rail">
            <span class="replay-track-fill" data-role="track-fill"></span>
            <span class="replay-rip-markers" data-role="death-markers"></span>
          </span>
          <span class="replay-playhead" data-role="playhead" tabindex="0" aria-label="Playhead"></span>
        </div>
      </div>
      <div class="controls-transport">
        <button type="button" class="replay-icon-btn" data-role="rewind" aria-label="Rewind 2× toggle" title="Rewind 2×">${replayerIcons.rewind}</button>
        <button type="button" class="replay-icon-btn" data-role="play-pause" aria-label="Play or pause">${replayerIcons.play}</button>
        <button type="button" class="replay-icon-btn" data-role="fast-forward" aria-label="Fast forward 2× toggle" title="Fast forward 2×">${replayerIcons.ff}</button>
      </div>
      <div class="controls-follow">
        <button type="button" class="replay-icon-btn" data-role="follow-prev" aria-label="Previous camera target">${replayerIcons.chevL}</button>
        <span class="replay-follow-name" data-role="follow-name">—</span>
        <button type="button" class="replay-icon-btn" data-role="follow-next" aria-label="Next camera target">${replayerIcons.chevR}</button>
      </div>
      <button type="button" class="controls-fullscreen replay-icon-btn" data-role="fullscreen" aria-label="Fullscreen" title="Fullscreen">${replayerIcons.fullscreen}</button>
    </div>
  </div>`
}

// ---- transport + volume -------------------------
export function createTransportPlayPauseUpdater(playPause, getPlaying) {
  let transportButtonMode = ''
  return function updateTransportPlayPauseButton() {
    const playing = getPlaying()
    const mode = playing ? 'pause' : 'play'
    const inner = playing ? replayerIcons.pause : replayerIcons.play
    const label = playing ? 'Pause' : 'Play'
    if (transportButtonMode !== mode) {
      transportButtonMode = mode
      playPause.innerHTML = inner
    }
    playPause.setAttribute('aria-label', label)
  }
}

export function updateReplayerVolumeButton(btnVolume, replayMuted) {
  btnVolume.innerHTML = replayMuted ? replayerIcons.volumeMuted : replayerIcons.volumeUnmuted
  btnVolume.setAttribute('aria-label', replayMuted ? 'Unmute' : 'Mute')
}

export function createReplayerControlsBinding(d) {
  let replayMutedBeforeScrub = null

  async function startReplayPlayback() {
    await d.audio.resume()
    d.audio.setThruster(false)
    d.replayLoop.playing = true
    d.replayLoop.resetLastFrameMs()
    d.replayLoop.scheduleFrame()
    d.updateTransportButton()
  }

  function toggleScanSpeed(mode) {
    const isRw = mode === 'rw2'
    const activeBtn = isRw ? d.btnRewind : d.btnFf
    const otherBtn = isRw ? d.btnFf : d.btnRewind
    if (d.replayLoop.speedMode === mode) {
      d.replayLoop.speedMode = 'normal'
      activeBtn.setAttribute('aria-pressed', 'false')
      d.replayLoop.playAccumulator = 0
      d.updateTransportButton()
      return
    }
    d.replayLoop.speedMode = mode
    otherBtn.setAttribute('aria-pressed', 'false')
    activeBtn.setAttribute('aria-pressed', 'true')
    d.replayLoop.playAccumulator = 0
    const canKickPlayback = isRw
      ? d.playback.appliedSteps > 0
      : d.playback.appliedSteps < d.duration
    if (!d.replayLoop.playing && canKickPlayback) {
      void startReplayPlayback()
    } else {
      d.updateTransportButton()
    }
  }

  return {
    canvas: d.canvas,
    playPause: d.playPause,
    btnRewind: d.btnRewind,
    btnFf: d.btnFf,
    trackHit: d.trackHit,
    followPrev: d.followPrev,
    followNext: d.followNext,
    btnVolume: d.btnVolume,
    btnClose: d.btnClose,
    getPlaying: () => d.replayLoop.playing,
    onPlayPauseClick: () => {
      void (async () => {
        if (d.playback.appliedSteps >= d.duration) {
          d.resetReplayParticles({ clearScrubTickDedupe: true })
          d.playback.seek(0)
          d.replayLoop.playAccumulator = 0
        }
        if (d.replayLoop.playing) {
          d.replayLoop.pausePlayback()
          return
        }
        await startReplayPlayback()
      })()
    },
    onRewindClick: () => toggleScanSpeed('rw2'),
    onFfClick: () => toggleScanSpeed('ff2'),
    onFollowPrevClick: () => {
      if (d.followOrder.length <= 1) return
      d.followCam.index = (d.followCam.index - 1 + d.followOrder.length) % d.followOrder.length
      d.updateFollowLabel()
      d.render()
    },
    onFollowNextClick: () => {
      if (d.followOrder.length <= 1) return
      d.followCam.index = (d.followCam.index + 1) % d.followOrder.length
      d.updateFollowLabel()
      d.render()
    },
    onTrackPointer(clientX) {
      const rect = d.trackRail.getBoundingClientRect()
      const ratio = rect.width > 0 ? (clientX - rect.left) / rect.width : 0
      const tick = replayTimelineRatioToTick(ratio, d.duration)
      d.scrubPlaybackToTick(tick)
    },
    muteForScrub() {
      if (replayMutedBeforeScrub != null) return
      replayMutedBeforeScrub = d.replayMute.muted
      d.replayMute.muted = true
      d.updateVolumeButton()
      syncReplayThruster({
        audio: d.audio,
        replayMuted: true,
        playback: d.playback,
        getFollowShip: d.getFollowShip
      })
    },
    restoreMuteAfterScrub() {
      if (replayMutedBeforeScrub == null) return
      d.replayMute.muted = replayMutedBeforeScrub
      replayMutedBeforeScrub = null
      d.updateVolumeButton()
      syncReplayThruster({
        audio: d.audio,
        replayMuted: d.replayMute.muted,
        playback: d.playback,
        getFollowShip: d.getFollowShip
      })
    },
    pausePlayback: () => d.replayLoop.pausePlayback(),
    resumePlaybackAfterScrub: () => d.replayLoop.resumePlaybackAfterScrub(),
    onVolumeClick: () => {
      d.replayMute.muted = !d.replayMute.muted
      d.updateVolumeButton()
      void d.audio.resume()
      syncReplayThruster({
        audio: d.audio,
        replayMuted: d.replayMute.muted,
        playback: d.playback,
        getFollowShip: d.getFollowShip
      })
    },
    onCloseClick: d.hidePopover
  }
}

export function bindReplayerControls(o) {
  const clickSubs = [
    [o.playPause, o.onPlayPauseClick],
    [o.canvas, () => o.playPause.click()],
    [o.btnRewind, o.onRewindClick],
    [o.btnFf, o.onFfClick],
    [o.followPrev, o.onFollowPrevClick],
    [o.followNext, o.onFollowNextClick],
    [o.btnVolume, o.onVolumeClick],
    [o.btnClose, o.onCloseClick]
  ]
  for (const [el, fn] of clickSubs) el.addEventListener('click', fn)

  const disposeTimeline = bindTimelineTrackScrub({
    trackHit: o.trackHit,
    getPlaying: o.getPlaying,
    pausePlayback: o.pausePlayback,
    resumePlaybackAfterScrub: o.resumePlaybackAfterScrub,
    onTrackPointer: o.onTrackPointer,
    muteForScrub: o.muteForScrub,
    restoreMuteAfterScrub: o.restoreMuteAfterScrub
  })

  return function disposeReplayerControls() {
    for (const [el, fn] of clickSubs) el.removeEventListener('click', fn)
    disposeTimeline()
  }
}
